import { type UseQueryResult } from '@tanstack/react-query';
import { type PartnerTreeNodeV2 } from '@sr/types';

export type FetchBusinessPartnersResult = {
  data: PartnerTreeNodeV2[];
  isLoading: boolean;
  isError: boolean;
  errors: unknown[];
};

type BusinessPartnerQueryResult = Pick<
  UseQueryResult<PartnerTreeNodeV2>,
  'data' | 'error' | 'isError' | 'isFetched' | 'isLoading'
>;

export const combineBusinessPartnerQueries = (
  results: BusinessPartnerQueryResult[],
): FetchBusinessPartnersResult => {
  const data = results
    .map((result) => result.data)
    .filter((partnerTree): partnerTree is PartnerTreeNodeV2 => partnerTree !== undefined);
  // Failed queries become loading again when focus retries them; keep any successful hierarchy visible.
  const isLoading = results.some(
    (result) => result.isLoading && (!result.isFetched || data.length === 0),
  );
  const isError = results.every((result) => result.isError);
  const errors = results.filter((result) => result.isError).map((result) => result.error);

  return { data, isLoading, isError, errors };
};
